import React from 'react';
import PropTypes from 'prop-types';
import toLower from 'lodash/toLower';

import ApplePayIcon from './icons/apple.svg';
import AndroidPayIcon from './icons/google.svg';

function getIcon(type) {
  switch(toLower(type)) {
    case 'apple_pay':
      return ApplePayIcon;
    case 'android':
      return AndroidPayIcon;
    default:
      return null;
  }
}

const defaultStyle = {
  display: 'inline-block',
  width: '30px',
  height: '30px',
  verticalAlign: 'middle',
  overflow: 'visible',
};

const WalletIcon = ({ style, className, type = 'card' }) => {
  const IconComponent = getIcon(type);
  if(IconComponent) {
    return (
      <IconComponent
        style={{ ...defaultStyle, ...style }}
        className={className}
        aria-label={`${type} payment icon`}
      />
    )
  }
  return null;
}

WalletIcon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  brand: PropTypes.string.isRequired,
};

WalletIcon.defaultProps = {
  style: {},
  className: '',
  brand: null,
};

export default WalletIcon;
